/**
 * ZeaHighland Actualités CBD — filters + lazy video playback.
 * Thumbnail first; iframe only after explicit play. No autoplay audio.
 */
(function () {
  'use strict';

  var YT_HOST = 'https://www.youtube-nocookie.com/embed/';
  var VIMEO_HOST = 'https://player.vimeo.com/video/';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function parseYouTubeId(url) {
    if (!url) return '';
    var m = String(url).match(
      /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?v=|embed\/|shorts\/|live\/))([\w-]{11})/
    );
    return m ? m[1] : '';
  }

  function parseVimeoId(url) {
    if (!url) return '';
    var m = String(url).match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return m ? m[1] : '';
  }

  function buildEmbed(url, provider) {
    var p = (provider || '').toLowerCase();
    var yt = parseYouTubeId(url);
    var vm = parseVimeoId(url);
    if (p === 'youtube' || yt) {
      var id = yt || url;
      return {
        type: 'iframe',
        src:
          YT_HOST +
          encodeURIComponent(id) +
          '?autoplay=1&rel=0&modestbranding=1&playsinline=1',
      };
    }
    if (p === 'vimeo' || vm) {
      var vid = vm || url;
      return {
        type: 'iframe',
        src: VIMEO_HOST + encodeURIComponent(vid) + '?autoplay=1&title=0&byline=0&portrait=0',
      };
    }
    if (p === 'html5' || /\.(mp4|webm|ogg)(\?|$)/i.test(url)) {
      return { type: 'video', src: url };
    }
    return null;
  }

  function clearPlayer(media) {
    var player = qs('[data-gal-news-player]', media);
    if (!player) return;
    player.hidden = true;
    player.innerHTML = '';
    media.classList.remove('is-playing');
  }

  function showFallback(card, media) {
    clearPlayer(media);
    var play = qs('[data-gal-news-play]', media);
    if (play) play.hidden = true;
    card.classList.add('gal-news-card--video-fallback');
  }

  function playVideo(btn) {
    var media = btn.closest('[data-gal-news-media]');
    var card = btn.closest('[data-gal-news-card]');
    if (!media || !card) return;

    var player = qs('[data-gal-news-player]', media);
    if (!player) return;

    var embed = buildEmbed(btn.getAttribute('data-video-url'), btn.getAttribute('data-video-provider'));
    if (!embed) {
      showFallback(card, media);
      return;
    }

    player.innerHTML = '';
    player.hidden = false;
    media.classList.add('is-playing');

    if (embed.type === 'iframe') {
      var iframe = document.createElement('iframe');
      iframe.src = embed.src;
      iframe.title = 'Lecture vidéo';
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('loading', 'lazy');
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.addEventListener('error', function () {
        showFallback(card, media);
      });
      player.appendChild(iframe);
    } else {
      var video = document.createElement('video');
      video.src = embed.src;
      video.controls = true;
      video.playsInline = true;
      video.autoplay = true;
      video.addEventListener('error', function () {
        showFallback(card, media);
      });
      player.appendChild(video);
    }
  }

  function setFilter(root, key) {
    var cards = qsa('[data-gal-news-card]', root);
    var buttons = qsa('[data-gal-news-filter]', root);
    var active = key || 'all';

    buttons.forEach(function (btn) {
      var on = btn.getAttribute('data-gal-news-filter') === active;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var visible = 0;
    cards.forEach(function (card) {
      var filters = (card.getAttribute('data-filters') || 'all').toLowerCase();
      var match = active === 'all' || filters.split(/\s+/).indexOf(active) !== -1;
      card.hidden = !match;
      if (match) visible += 1;
    });

    if (active === 'all') {
      initInterleave(root);
    }

    var empty = qs('[data-gal-news-filter-empty]', root);
    if (empty) empty.hidden = visible > 0;

    try {
      var url = new URL(window.location.href);
      if (active === 'all') url.searchParams.delete('filter');
      else url.searchParams.set('filter', active);
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (e) {
      /* ignore */
    }
  }

  function initFilters(root) {
    var bar = qs('[data-gal-news-filters]', root);
    if (!bar) return;

    bar.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-gal-news-filter]');
      if (!btn || !bar.contains(btn)) return;
      setFilter(root, btn.getAttribute('data-gal-news-filter'));
    });

    var initial = 'all';
    try {
      initial = new URL(window.location.href).searchParams.get('filter') || 'all';
    } catch (e) {
      initial = 'all';
    }
    setFilter(root, initial);
  }

  function initPlay(root) {
    root.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-gal-news-play]');
      if (!btn || !root.contains(btn)) return;
      ev.preventDefault();
      playVideo(btn);
    });
  }

  function initSort(root) {
    var select = qs('[data-gal-news-sort]', root);
    if (!select) return;
    select.addEventListener('change', function () {
      var containers = qsa('.gal-news-hub__compact, .gal-news-hub__grid, .gal-news-home__grid', root);
      containers.forEach(function (container) {
        var cards = qsa('[data-gal-news-card]:not([data-placeholder])', container);
        if (cards.length < 2) return;
        if (select.value === 'oldest') {
          cards.reverse().forEach(function (card) {
            container.appendChild(card);
          });
        } else {
          cards
            .slice()
            .reverse()
            .forEach(function (card) {
              container.insertBefore(card, container.firstChild);
            });
        }
      });
    });
  }

  /**
   * Visual regional balance for "Tout": FR → EU → USA → Monde round-robin.
   * Does not drop cards; empty regions simply skip.
   */
  function interleaveRegions(container) {
    if (!container) return;
    var cards = qsa('[data-gal-news-card]:not([data-placeholder])', container);
    if (cards.length < 3) return;
    var buckets = { france: [], europe: [], usa: [], monde: [], other: [] };
    cards.forEach(function (card) {
      var r = (card.getAttribute('data-region') || '').toLowerCase();
      if (r === 'france' || r === 'europe' || r === 'usa' || r === 'monde') buckets[r].push(card);
      else buckets.other.push(card);
    });
    var order = [];
    var i = 0;
    var keys = ['france', 'europe', 'usa', 'monde', 'other'];
    while (order.length < cards.length && i < cards.length + 2) {
      keys.forEach(function (k) {
        if (buckets[k][i]) order.push(buckets[k][i]);
      });
      i += 1;
    }
    order.forEach(function (card) {
      container.appendChild(card);
    });
  }

  function initInterleave(root) {
    qsa('[data-gal-news-interleave]', root).forEach(interleaveRegions);
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-gal-news-ready') === '1') return;
    root.setAttribute('data-gal-news-ready', '1');
    initInterleave(root);
    initFilters(root);
    initPlay(root);
    initSort(root);
  }

  function boot() {
    qsa('[data-gal-news]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var root = ev.target && ev.target.querySelector
      ? ev.target.querySelector('[data-gal-news]')
      : null;
    if (root) {
      root.removeAttribute('data-gal-news-ready');
      initRoot(root);
    }
  });
})();
